import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png"; // adjust path if needed
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button
          className="policy-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">Terms &amp; Conditions</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. Agreement</h2>
          <p>
            These Terms govern your access to and use of Kairos (the “Service”).
            By using the Service, you agree to these Terms. If you do not agree,
            do not use the Service.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Accounts</h2>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your login.</li>
            <li>You must provide accurate information and keep it up to date.</li>
            <li>You are responsible for activity that occurs under your account.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Using the Service</h2>
          <ul>
            <li>
              You may use Kairos to create and publish websites, manage assets, and
              interact with AI features.
            </li>
            <li>
              You agree not to misuse the Service (e.g., hacking, scraping, abusing rate limits,
              or interfering with normal operation).
            </li>
            <li>
              You agree not to upload or generate illegal content, malware, or content that infringes
              on others’ rights.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Your content</h2>
          <p>
            You own the content you create and upload (“User Content”). You grant Kairos a limited license
            to host, store, and process your content only as needed to provide and improve the Service.
          </p>
        </div>

        <div className="policy-section">
          <h2>5. AI features</h2>
          <ul>
            <li>
              AI outputs may be inaccurate or incomplete. You are responsible for reviewing and verifying
              outputs before publishing or relying on them.
            </li>
            <li>
              Do not submit sensitive personal information in prompts unless necessary.
            </li>
            <li>
              You are responsible for ensuring your use of AI outputs complies with applicable laws and
              third-party rights.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Plans, billing and credits</h2>
          <p>
            Some features may require a subscription or credits. Pricing, plan limits, and billing terms are
            described on the pricing page and relevant policy pages (Refund / Subscription Policy).
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Acceptable use</h2>
          <ul>
            <li>No illegal, harmful, or abusive behavior.</li>
            <li>No phishing, impersonation, or fraud.</li>
            <li>No uploading viruses, malicious code, or attempting to bypass security.</li>
            <li>No infringement of copyright, trademarks, or other rights.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>8. Termination</h2>
          <p>
            You may stop using the Service at any time. We may suspend or terminate access if you violate
            these Terms, if required by law, or to protect the Service and other users.
          </p>
        </div>

        <div className="policy-section">
          <h2>9. Disclaimers</h2>
          <p>
            The Service is provided “as is” and “as available.” Kairos does not guarantee uninterrupted,
            error-free operation or that AI outputs will be correct or suitable for your needs.
          </p>
        </div>

        <div className="policy-section">
          <h2>10. Limitation of liability</h2>
          <p>
            To the maximum extent allowed by law, Kairos is not liable for indirect, incidental, special,
            consequential, or punitive damages, or any loss of profits, data, or goodwill arising from your
            use of the Service.
          </p>
        </div>

        <div className="policy-section">
          <h2>11. Changes</h2>
          <p>
            We may update these Terms from time to time. If changes are material, we will take reasonable steps
            to notify you. Continued use after changes means you accept the updated Terms.
          </p>
        </div>

        <div className="policy-section">
          <h2>12. Contact</h2>
          <p>
            Questions about these Terms? Contact: <strong>support@yourdomain.com</strong>
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default TermsAndConditions;
